import React from "react";
import PropTypes from "prop-types";
import * as constants from "@wunderflats/constants";
import AppHeader from "../../../../../../components/AppHeader/AppHeader";
import { Link } from "../../../../../../components/DesignSystem/Button/Button";
import FeaturedCompanies from "../../../../../../components/FeaturedCompanies/FeaturedCompanies";
import Footer from "../../../../../../components/Footer/Footer";
import FreshdeskHelpWidget from "../../../../../../components/FreshdeskHelpWidget/FreshdeskHelpWidget";
import SpaPagePropTypes from "../../../../../../types/SpaPage/SpaPagePropTypes";
import scrollPosition from "../../../../../../utils/scroll-position";
import * as sessionStorage from "../../../../../../utils/sessionStorage";
import PageHead from "../../../../PageHead";
import Benefits from "../sections/Benefits/Benefits";
import Faq from "../sections/FAQ/FAQ";
import Hero from "../sections/Hero/Hero";
import HowTo from "../sections/HowTo/HowTo";
import Statistics from "../sections/Statistics/Statistics";
import TakeAction from "../sections/TakeAction/TakeAction";
import "./LandingPage.scss";

const INCENTIVE_AMOUNT = constants.misc.referral.INCENTIVE_AMOUNT / 100;

class LandingPage extends React.PureComponent {
  static propTypes = {
    ...SpaPagePropTypes,
    pageData: PropTypes.shape({
      invitedBy: PropTypes.string.isRequired,
      faqData: PropTypes.array,
    }),
  };

  constructor() {
    super();
    this.state = {
      showCTAInHeader: false,
      anchorCTAForMobile: false,
    };
    this.footerRef = React.createRef();
  }

  componentDidMount() {
    this.mobileCTAButtonHeight = document.querySelector(
      ".LandingPage-takeAction-button-outer",
    ).offsetHeight;

    this.onResize();
    this.onScroll();
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("resize", this.onResize);

    if (this.props.params.referralId) {
      sessionStorage.set("referralId", this.props.params.referralId);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.footerTop = this.footerRef.current.offsetTop;
    if (window.innerWidth <= 768) {
      this.setState({ smallScreen: true });
    } else {
      this.setState({ smallScreen: false });
    }
  };

  onScroll = () => {
    const scrollPos = scrollPosition();
    const scrollBottomPosition = scrollPos.y + window.innerHeight;

    this.setState({
      showCTAInHeader:
        window.innerWidth >= 992 && scrollPos.y > window.innerHeight / 3,
      anchorCTAForMobile:
        this.state.smallScreen &&
        scrollBottomPosition >= this.footerTop + this.mobileCTAButtonHeight,
    });
  };

  render() {
    const {
      t,
      lang,
      user,
      api,
      translationUrls,
      currentUrl,
      pageData: { invitedBy, faqData },
      url,
      analytics,
    } = this.props;

    const headProps = {
      title: t("spages.referrals.landing.pageTitle"),
      translationUrls,
    };

    return (
      <div className="LandingPage">
        <PageHead {...headProps} />
        <AppHeader
          currentUrl={currentUrl}
          lang={lang}
          t={t}
          theme="white"
          translationUrls={translationUrls}
          user={user}
          analyticsEvent={analytics?.event}
        >
          <nav
            className={`LandingPage-AppHeader-overlay${
              this.state.showCTAInHeader ? " visible" : ""
            }`}
          >
            <Link href={url("createListing")} colorVariant="primary">
              {t("spages.referrals.landing.sections.TakeAction.action")}
            </Link>
          </nav>
        </AppHeader>
        <div className="LandingPage-inner">
          <Hero
            t={t}
            invitedBy={invitedBy}
            referralAmount={INCENTIVE_AMOUNT}
            lang={lang}
            url={url}
          />
          <div className="LandingPage-separator" />
          <Benefits t={t} />
          <HowTo t={t} lang={lang} />
          <div className="LandingPage-separator" />
          <Statistics t={t} getStats={api ? api.getStats : null} />
          <section className="LandingPage-section LandingPage-companies">
            <FeaturedCompanies />
          </section>
          <div className="LandingPage-separator" />
          {faqData.length > 0 && <Faq faqData={faqData} t={t} />}
          <TakeAction
            t={t}
            anchored={this.state.anchorCTAForMobile}
            lang={lang}
            url={url}
          />
          <div className="LandingPage-separator hide-lt-medium" />
        </div>
        <Footer url={url} user={user} ref={this.footerRef} />

        <FreshdeskHelpWidget isButtonVisible={false} />
      </div>
    );
  }
}

export default LandingPage;
